import { createContext } from 'react';

export const TooltipContext = createContext<{ visible: boolean }>({ visible: false });
